import { WorkflowConfigError, WorkflowErrorType } from 'dashboard/models/workflow';
import { WorkflowStepParallel } from 'dashboard/models/workflow-version';

export const validateParallelStep = (step: WorkflowStepParallel): WorkflowConfigError[] => {
  if (step.branches.length === 0) {
    return [
      {
        token: step.token,
        field: 'branches',
        message: 'Must have at least one branch',
        type: WorkflowErrorType.Publish,
      },
    ];
  }

  return [];
};
